<template>
<component :is='c_name' :md4="md==4" :md8="md==8">
  <b><fs1-span>Functional Location</fs1-span></b>
  <v-btn @click="value.push('')" small color="primary" >
    <v-icon>add</v-icon>
    <span>Agregar</span>
  </v-btn>
  <ul>
    <li v-for="(ln,i) in value" :key="i" style="display: inline-block;margin-right: 10px;">
      <in-text v-model="value[i]" placeholder=" ingresar texto" style="display:inline-block;width: auto;padding: 0 !important;"/>
      <v-icon @click="value.splice(value.indexOf(ln), 1)" style="display:inline-block;">delete</v-icon>
    </li>
  </ul>

</component>
</template>

<script>
export default {
  props: ['value','md','div'],
  data() {
    return {
      model:null,
    };
  },
  computed: {
    c_name(){ return this.div? 'div':'v-flex'},
  },
  /* watch: {
    'value'(v){ this.model=v },
    'model'(v){ this.$emit('update:value', v) }
  }, */
  //created(){ this.model=[undefined].includes(this.value)?null:this.value },
  methods: { }, // methods
};
</script>
